import React, { createContext, useContext, useReducer } from "react";
import { initialState, documentosSetoriaisReducer, DocumentosSetoriaisState } from "./documentos-setoriais-reducer";

type DocumentosSetoriaisContextType = {
    state: DocumentosSetoriaisState;
    dispatch: React.Dispatch<any>;
};

const DocumentosSetoriaisContext = createContext<DocumentosSetoriaisContextType | undefined>(undefined);

export const DocumentosSetoriaisProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(documentosSetoriaisReducer, initialState);

    return (
        <DocumentosSetoriaisContext.Provider value={{ state, dispatch }}>
            {children}
        </DocumentosSetoriaisContext.Provider>
    );
};

export const useDocumentosSetoriaisState = () => {
    const context = useContext(DocumentosSetoriaisContext);
    if (!context) {
        throw new Error("useDocumentosSetoriaisState must be used within DocumentosSetoriaisProvider");
    }
    return context.state;
};

export const useDocumentosSetoriaisDispatch = () => {
    const context = useContext(DocumentosSetoriaisContext);
    if (!context) {
        throw new Error("useDocumentosSetoriaisDispatch must be used within DocumentosSetoriaisProvider");
    }
    return context.dispatch;
};
